module.exports = __webpack_public_path__ + "static/img/butterflyImg.7c4bb84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/butterflyImg.png
// module id = RZO2
// module chunks = 1